import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { NoteDTO } from '../models/dto/note.dto';
import { NoteUpdateDTO } from '../models/dto/note-update.dto';
import { NoteDeletedResponseDTO } from '../models/dto/note-deleted-response.dto';

@Injectable({
    providedIn: 'root',
})
export class NoteDataService {
    constructor(private httpClient: HttpClient) {}

    add(ticketId: number, noteModel: NoteUpdateDTO): Observable<NoteDTO> {
        return this.httpClient.post<NoteDTO>(environment.apiInboxUrl + 'tickets/' + ticketId + '/notes', noteModel);
    }

    delete(ticketId: number, noteId: number): Observable<NoteDeletedResponseDTO> {
        return this.httpClient.delete<NoteDeletedResponseDTO>(
            environment.apiInboxUrl + 'tickets/' + ticketId + '/notes/' + noteId,
        );
    }

    disableAccess(ticketId: number, noteId: number): Observable<void> {
        return this.httpClient.patch<void>(
            environment.apiInboxUrl + 'tickets/' + ticketId + '/notes/' + noteId + '/shareAccess/disable',
            {},
        );
    }

    getAll(ticketId: number): Observable<NoteDTO[]> {
        return this.httpClient.get<NoteDTO[]>(environment.apiInboxUrl + 'tickets/' + ticketId + '/notes');
    }

    readAll(ticketId: number): Observable<void> {
        return this.httpClient.patch<void>(environment.apiInboxUrl + 'tickets/' + ticketId + '/notes/IsRead/', null);
    }

    shareAccess(ticketId: number, noteId: number, userIds: string[]): Observable<void> {
        return this.httpClient.post<void>(
            environment.apiInboxUrl + 'tickets/' + ticketId + '/notes/' + noteId + '/shareAccess',
            userIds,
        );
    }

    update(ticketId: number, noteId: number, noteModel: NoteUpdateDTO): Observable<NoteDTO> {
        return this.httpClient.patch<NoteDTO>(
            environment.apiInboxUrl + 'tickets/' + ticketId + '/notes/' + noteId,
            noteModel,
        );
    }
}
